module.exports = __webpack_public_path__ + "static/media/checked-icon.cc90a454.svg";